import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axiosInstance from "./config/axiosInstance";

window.moment = require("../node_modules/moment");
window._ = require("../node_modules/lodash");

Vue.config.productionTip = false

Vue.prototype.axios = axiosInstance;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
